module.exports = __webpack_public_path__ + "static/media/axle_b_middle_bar_inspection.1e69f5dc.svg";